/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  ButtonGroup,
  CircularProgress,
  IconButton,
  Paper,
  TableContainer,
  Tooltip,
} from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { handleViewOpen, rowValue } from "../../redux/Reducer/ModalSlice";
import VolunteerFilterNoAdd from "../Others/VolunteerFilterNoAdd";
// import VolunteerAdd from "./VolunteerAdd";
// import VolunteerEdit from "./VolunteerEdit";
import ViewModal from "../modal/ViewModal";
// import VolunteerProfile from "./VolunteerProfile";
// import HistoryModal from "../modal/HistoryModal";
// import HistoryTableAdd from "./HistoryTable/HistoryTableAdd";
import moment from "moment";
import useCurrentTrialsVolunteerList from "../../hooks/useCurrentTrialsVolunteerList";
import Pagination from "../table-components/pagination/Pagination";
import TableComp from "../table-components/table/TableComp";
import VolunteerProfile from "../Volunteer/VolunteerProfile";

const CurrentStudyVolunteersList = ({ user, studyCode }) => {
  const dispatch = useDispatch();
  const [
    currentTrialsVolunteerList,
    isLoading,
    isError,
    error,
    isSuccess,
    refetch,
  ] = useCurrentTrialsVolunteerList(studyCode);

  // function handleEdit(rowData) {
  //   dispatch(handleEditOpen());
  //   dispatch(rowValue(rowData));
  // }
  function handleView(rowData) {
    dispatch(handleViewOpen());
    dispatch(rowValue(rowData));
  }
  // function handleHistory(rowData) {
  //   dispatch(handleHistoryOpenModal());
  //   dispatch(rowValue(rowData));
  // }

  // const n = userData.ugleve_name;

  const columns = React.useMemo(
    () => [
      // {
      //   Header: "SL No.",
      //   Cell: (row) => {
      //     return <div>{Number(row.row.id) + 1}</div>;
      //   },
      //   // Header: "SL No.",
      //   // accessor: "index",
      //   // Cell: (row) => {
      //   //   return <div>{Number(row.row.id) + 1}</div>;
      //   // },
      //   Filter: false,
      // },
      {
        Header: "PID No",
        accessor: "vol_id",
        Filter: false,
      },
      {
        Header: "Name",
        accessor: "full_name",
        Filter: false,
      },

      {
        Header: "Date of Birth",
        accessor: "dob",
        Cell: (row) => (
          <div>{moment(row.row.original.dob).format("DD MMM YYYY")}</div>
        ),
        Filter: false,
      },
      {
        Header: "Sex",
        accessor: "sex",
        Filter: false,
      },

      {
        Header: "Occupation",
        accessor: "occupation_name",
        Filter: false,
      },

      {
        Header: "Contact Number",
        accessor: "contact_phone",
        Filter: false,
      },
      // {
      //   Header: "Active Status",
      //   accessor: "active_fg",
      //   Filter: false,
      //   Cell: (row) => (
      //     <div
      //       style={{
      //         marginLeft: "10Px",
      //         display: "flex",
      //         justifyContent: "start",
      //         alignItem: "center",
      //       }}
      //     >
      //       {row.row.original.active_fg === "1" ? (
      //         <StatusContainer>
      //           <ActiveStatus>Active</ActiveStatus>
      //         </StatusContainer>
      //       ) : (
      //         <StatusContainer>
      //           <InactiveStatus>Inactive</InactiveStatus>
      //         </StatusContainer>
      //       )}
      //     </div>
      //   ),
      // },
      // ! action btns
      {
        Header: () => <div style={{ marginLeft: "20px" }}>Action</div>,
        accessor: "col5",
        Cell: (row) => (
          <ButtonGroup
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            {/* edit icon */}
            {/* {(user === "Admin" || user === "Developer") && (
      //         <IconButton
      //           size="small"
      //           sx={{ "&:hover": { color: "#2e68e8" } }}
      //           style={{ color: "#2196F3" }}
      //           variant="none"
      //           onClick={() => handleEdit(row.row.original)}
      //         >
      //           <Tooltip title="Update">
      //             <EditIcon
      //               // fontSize="small"
      //               sx={{ fontSize: 18 }}
      //             />
      //           </Tooltip>
      //         </IconButton>
      //       )} */}
            //{" "}
            {/* <IconButton
      //         size="small"
      //         sx={{ "&:hover": { color: "#2e68e8" } }}
      //         style={{ color: "#2196F3" }}
      //         variant="none"
      //         onClick={() => handleEdit(row.row.original)}
      //       >
      //         <Tooltip title="Update">
      //           <EditIcon
      //             // fontSize="small"
      //             sx={{ fontSize: 18 }}
      //           />
      //         </Tooltip>
      //       </IconButton> */}
            // {/* <MouseDiv> */}
            // {/* //! preview details icon */}
            <IconButton
              size="small"
              sx={{ "&:hover": { color: "#2e68e8" } }}
              style={{ color: "#189A2E" }}
              variant="none"
              onClick={() => {
                handleView(row.row.original);
              }}
            >
              <Tooltip title="Details">
                <VisibilityIcon
                  sx={{ fontSize: 18 }}
                  // fontSize="small"
                />
              </Tooltip>
            </IconButton>
          </ButtonGroup>
        ),
        Filter: false,
        disableSortBy: true,
      },
    ],
    []
  );

  // const add = useSelector((state) => state.Modal.add);
  // const edit = useSelector((state) => state.Modal.edit);

  // useEffect(() => {
  //   if (!add) {
  //     refetch();
  //   }
  // }, [add]);

  // useEffect(() => {
  //   if (!edit) {
  //     refetch();
  //   }
  // }, [edit]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    prepareRow,
    gotoPage,
    pageCount,
    setPageSize,
    state,
    setGlobalFilter,
  } = useTable(
    { columns, data: currentTrialsVolunteerList },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination
  );

  const { globalFilter } = state;
  const { pageIndex, pageSize } = state;
  return (
    <>
      <div>
        <VolunteerFilterNoAdd
          filter={globalFilter}
          setFilter={setGlobalFilter}
        />
      </div>

      <TableContainer component={Paper}>
        <TableComp
          getTableProps={getTableProps}
          headerGroups={headerGroups}
          getTableBodyProps={getTableBodyProps}
          page={page}
          prepareRow={prepareRow}
          pageIndex={pageIndex}
        />

        {isLoading && (
          <div
            style={
              {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "280px",
              }
              // display:"flex",
            }
          >
            <CircularProgress />
          </div>
        )}

        <Pagination
          page={page}
          pageIndex={pageIndex}
          gotoPage={gotoPage}
          canPreviousPage={canPreviousPage}
          previousPage={previousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageCount={pageCount}
        />
      </TableContainer>

      {/* modals */}

      {/* <AddModal ModalWidth="md" ModalTitle="Add Volunteer Information">
        <VolunteerAdd />
      </AddModal> */}

      {/* <EditModal ModalWidth="md" ModalTitle="Edit Volunteer Information">
        <VolunteerEdit />
      </EditModal> */}

      {/* <ViewModal ModalWidth="md" ModalTitle="Volunteer Profile">
        <VolunteerAttachmentProfile />
      </ViewModal> */}

      <ViewModal ModalWidth="md" ModalTitle="Volunteer Profile">
        <VolunteerProfile />
      </ViewModal>

      {/* <HistoryModal ModalWidth="md" ModalTitle="Volunteer History">
        <HistoryTableAdd />
      </HistoryModal> */}
    </>
  );
};

export default CurrentStudyVolunteersList;
